import React, { useState, useEffect, useContext, useMemo } from "react";
import Slideshow from "./Slideshow";
import Moviecard from "./Moviecard";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { fetchBanner, fetchSectionList } from "./Api";
import { Contextone } from "./Context";
import Skeleton from "react-loading-skeleton";
import styled from 'styled-components';
import "react-loading-skeleton/dist/skeleton.css";

const ShimmerContainer = styled.div`
  height: 230px;
  width: 178px;
  margin: 0 10px 30px 0;
  background: #3a3a3a;
  background-image: linear-gradient(to right, #3a3a3a 0%, #3f3f3f 10%, #4a4a4a 20%, #3f3f3f 30%, #3a3a3a 50%, #3a3a3a 100%);
  background-repeat: no-repeat;
  background-size: 1900px 800px;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: ease-in-out;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

const ShimmerRow = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
        {[...Array(7)].map((_, index) => (
            <ShimmerContainer key={index} />
        ))}
    </div>
);

const News = () => {
  const [sectionlist, setSectionlist] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [banner, setBanner] = useState([]);
  const [bannerData, setBannerData] = useState('');
  const [languageId, setLanguageId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [isPageUrl, setLastPageUrl] = useState("");

  const countercontext = useContext(Contextone);
  const isurl = countercontext.isDomain;
  const apiUrl = `https://${isurl}`;

  const typeId = 5;
  const isHomepage = 2;

  useEffect(() => {
    setPage(1);
    setLoading(true);
    setBannerData('');
    setSectionlist([]);

    fetchData(typeId, isHomepage, languageId, 1);
  }, [languageId]);

  const fetchData = async (type_id, is_home, lang, pageNum) => {
    try {
      const bannerData = await fetchBanner(apiUrl, type_id, is_home, lang);
      const sectionData = await fetchSectionList(apiUrl, type_id, is_home, pageNum);

      setBanner(bannerData.result);

      if (sectionData.result.data) {
        setSectionlist((prev) => [...prev, ...sectionData.result.data]);
      } else {
        setSectionlist((prev) => [...prev, ...sectionData.result]);
      }

      setLastPageUrl(sectionData.next_page_url);

      if (sectionData.next_page_url != null) {
        setPage((prevPage) => prevPage + 1);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
      setLoadingMore(false)
    }
  };

  useEffect(() => {
    if (banner.length > 0) {
      setBannerData(banner[0].id);
    } else {
      setBannerData(null);
    }
  }, [banner]);

  const loadMoreData = () => {
    if (!loading && isPageUrl && !loadingMore) {
      
      setLoadingMore(true)
      fetchData(typeId, isHomepage, languageId, page);
    } 
  };

  return (
    <>
      <div>
        {loading && page === 1 ? (
          <div style={{ marginTop: "60px", width: "100vw", minWidth: "100vw" }}>
            <div className="shimmer-container">
              <ShimmerThumbnail className="shimmer-thumbnail" />
            </div>
            <Moviecard loading={true} />
          </div>
        ) : (
          <div className="home-body">
            {bannerData ? (
              <>
                <Slideshow data={banner} bannervisible={true} />
                <Moviecard data={sectionlist} bannervisible={true}loading={loading} loadMoreData={loadMoreData} pageUrl={isPageUrl}/>
              </>
            ) : (
              <>
                <Moviecard data={sectionlist} bannervisible={false} loading={loading} loadMoreData={loadMoreData} pageUrl={isPageUrl}/>
              </>
            )}
            {loadingMore && (
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <ShimmerRow />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default News;
